<template>
  <div>
  
    <div class="card card-body p-0" id="card_body" style="border-radius: 10px">
      <ticket-filters :tickets="tickets" :page="page" @skeletonLoader="setskeletonLoader" @setPage="setPage" @selectSupportTab="selTab" @setSupportStatus="setStatus" id="support_status" @setFilters="filtersData"></ticket-filters>
      <tickets-table :tickets="tickets" :total_tickets="totalTickets" :total_tickets_perpage="totalRows" :displayed_tickets="displyedRows" :totalPages="totalPages" :page="page" :selTab="sel_tab" :setskeletonLoader="displayLoader" @setPage="setPage" :setStatus="status" ></tickets-table>
    </div>
  </div>
</template>

<script>
  import helpers from "@/helpers.js";
  import ticketFilters from "./ticket_filters";
  import ticketsTable from "./tickets_table";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      ticketsTable,ticketFilters,VueSkeletonLoader,
    },

    data: function () {
      return {
        page: 0,
        status:'all',
        sel_tab: 'all',
        total_tickets: 0,
        total_tickets_perpage: 0,
        displayed_tickets: 0,
        displayLoader: false,
        organization_search: '',
        category_search: '',
        search:''
      };
    },

    computed: {
      tickets: function () {
        return this.$store.getters["support/tickets"];
      },
      totalPages: function () {
        return this.$store.getters["support/totalPages"];
      },
      totalTickets: function () {
        return this.$store.getters["support/totalTickets"];
      },
      displyedRows: function () {
        return this.$store.getters["support/supportTicketsPerPage"];
      },
      totalRows: function () {
        return this.$store.getters["support/ticketsPerPage"];
      },
    },

    created: function () {
      if(localStorage.getItem("supportTab") != null){
         localStorage.getItem("supportTab") == 'all';
         this.setStatus('all');
         this.selTab('all');
        //  this.setskeletonLoader(false);
      }
      window.addEventListener('scroll', this.handleScroll);
      // this.selTab(localStorage.getItem("tab"));
      this.page = helpers.getPageQuery();

    }, 
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
     },
    mounted:function(){
      if( $("#navbarResponsive").hasClass("show")){
        $("#navbarResponsive").toggleClass("show");
      }
       
    },

    watch: {
      page: function (val) {
        let status_val = this.status;
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setskeletonLoader(true);
        this.$store.dispatch("support/getAllTickets", [val, status_val,this.search,true,this.organization_search,this.category_search])
        .then(() => {
          setTimeout(() => {
          // loader.hide();
            this.setskeletonLoader(false);
          }, 1500);
        });
      
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
      },
      setStatus(status) {
        this.status = status;
        localStorage.setItem("supportTab", status);
      },
      selTab(event) {
        this.sel_tab = event;
        localStorage.setItem("supportTab", event);
      },
      setskeletonLoader(event){
        this.displayLoader= event;
        this.$forceUpdate();
      },
      handleScroll(event){
         $(".hide-menu").removeClass('show');
      },

      filtersData(search,organization,category){
        this.search = search;
        this.organization_search = organization;
        this.category_search = category
      }
    },
  };
</script>
<style scoped>
@media (min-width: 320px) and (max-width:680px){
  #card_body{
    width:  100% !important;
    border-radius: 0px !important;
    /* width: 108% !important;
    border-radius: 0px !important;
    margin-left: -17px; */
  }
  #support_status{
    /* bottom: 0 !important; */
    position: fixed !important;
    width: 100% !important;
    z-index: 2;
  }
  
}
</style>